import axios, { type AxiosRequestConfig } from "axios";
export default class ApiService {
  static instance: ApiService;

  public static get Instance() {
    return ApiService.instance;
  }

  public static async create() {
    ApiService.instance = new ApiService();
  }

  async GetData(relativeUrl: string, params = {}, returnData = true): Promise<object> {
    return await this.CallApi(relativeUrl, true, params, returnData);
  }
  async PostData(relativeUrl: string, params = {}, returnData = true): Promise<object> {
    return await this.CallApi(relativeUrl, false, params, returnData);
  }

  private async CallApi(
    relativeUrl: string,
    isGet: boolean = true,
    params = {},
    returnData = true
  ): Promise<object> {
    var data = undefined;
    const url = relativeUrl;
    const config: AxiosRequestConfig = { method: isGet ? "get" : "post" };
    if (params) {
      config["params"] = params;
    }

    let response;
    if (isGet) {
      response = await axios.get(url, config);
      if (returnData) {
        if (response.status == 200) {
          data = response.data;
        }
      } else {
        data = response;
      }
    } else {
      response = await axios.post(url, params);
      if (returnData) {
        if (response.status == 200) {
          data = response.data;
        }
      } else {
        data = response;
      }
    }
    return data;
  }
}
